module.exports = __webpack_public_path__ + "img/s1_t1_02.1d217ebd.jpeg";